import { fetchAuthSession } from '@aws-amplify/auth'
import { accessRequest } from './authConfig'
import { storeTokenData } from './storageUtils'

/**
 * Generates a completely new token using MSAL
 * @param {object} instance - MSAL instance
 * @returns {object} - Token object with accessToken
 */
export const generateNewToken = async (instance) => {
  try {
    const getNewToken = await instance.acquireTokenSilent({
      ...accessRequest
    })

    const tokenObject = {
      accessToken: getNewToken?.accessToken || '',
      expiresOn: getNewToken?.expiresOn || '',
      extExpiresOn: getNewToken?.extExpiresOn || ''
    }

    storeTokenData(tokenObject)
    return tokenObject
  } catch {
    throw new Error('Failed to generate new token')
  }
}

/**
 * Fetches access token for Cognito user
 * @returns {Promise<string>} - Access token
 */
export const fetchAccessTokenForCognitoUser = async () => {
  try {
    const session = await fetchAuthSession()
    const accessToken = session.tokens?.accessToken?.toString()
    return accessToken
  } catch (error) {
    console.error('Error fetching Cognito access token:', error)
    return null
  }
}